import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import {
  updateAutoMatchBlueprintModalContentShown,
  updateSelectedAutoMatchBlueprint,
  updateShowAutoMatchBlueprintModal,
} from "@src/reducers/your-reducer";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { autoMatchBlueprintUseCase } from "@src/cloud-connect/blueprint/use-cases/auto-match-blueprint-use-case";
import { Help } from "@src/cloud-connect/help/entities/help";
import { HelpRepository } from "@src/cloud-connect/help/repositories/help-repository";

export const useFindAutoMatchBlueprintModalContentHook = () => {
  const logger = getLogger();
  const dispatch = useDispatch();

  const [suggestedBlueprintsArray, setSuggestedBlueprintsArray] = useState([]);
  const [popoverPosition, setPopoverPosition] = useState({ x: 0, y: 0 });
  const [activePopover, setActivePopover] = useState(null);
  const [activeBlueprint, setActiveBlueprint] = useState(null);
  const [loadingBlueprintsList, setLoadingBlueprintsList] = useState(true);
  const modalRef = useRef<HTMLDivElement>(null);

  const closeModal = () => {
    dispatch(updateShowAutoMatchBlueprintModal(false));
  };

  const handleApplyBlueprint = () => {
    dispatch(updateAutoMatchBlueprintModalContentShown("apply"));
    dispatch(updateSelectedAutoMatchBlueprint(activeBlueprint));
  };

  const loadSuggestedBlueprints = async () => {
    setLoadingBlueprintsList(true);

    const blueprints = await autoMatchBlueprintUseCase();
    logger.debug("loadSuggestedBlueprints", { blueprints: blueprints });

    setSuggestedBlueprintsArray(blueprints);

    setLoadingBlueprintsList(false);
  };

  const blueprintSupportLinkBuilder = () => {
    const help = new Help(new HelpRepository());
    return help.getBlueprintHelpRequestUrl();
  };

  useEffect(() => {
    loadSuggestedBlueprints();
  }, []);

  return {
    modalRef,
    suggestedBlueprintsArray,
    popoverPosition,
    activeBlueprint,
    activePopover,
    loadingBlueprintsList,
    setPopoverPosition,
    setActiveBlueprint,
    setActivePopover,
    closeModal,
    handleApplyBlueprint,
    blueprintSupportLinkBuilder,
  };
};
